var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    fillOpacity: 0.2,
    d: "M16 2.38a13.63 13.63 0 1 0 0 27.25 13.63 13.63 0 0 0 0-27.25Zm0 3.25a10.38 10.38 0 1 1 0 20.75 10.38 10.38 0 0 1 0-20.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.45 2.38a13.63 13.63 0 1 1-9.6 23.3 1.63 1.63 0 1 1 2.3-2.31 10.38 10.38 0 1 0 7.3-17.74 1.63 1.63 0 0 1 0-3.26Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.58935725.svg";
export { ForwardRef as ReactComponent };